import * as React from 'react';
// import PeopleIcon from '@mui/icons-material/People';
import AssignmentIcon from '@mui/icons-material/Assignment';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import GearIcon from '@mui/icons-material/Settings';
import ScienceIcon from '@mui/icons-material/Science';
import { List, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { Dashboard as DashboardIcon } from '@mui/icons-material';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { Link } from 'react-router-dom';
import * as amplitude from '@amplitude/analytics-browser';
import { useSelector } from 'react-redux';
// import { selectTenant } from '../redux/userSlice';

const handleTrackEvent = (eventName) => {
  amplitude.track(eventName, {
    // You can add additional properties here if needed
  });
};

// Functional component to use useSelector
export const MainListItems = ({ tenantId }) => {
  const selectedTenant = useSelector((state) => state.user?.selectedTenant);

  // Prefer URL param; fall back to Redux state. Never use an undefined tenantId
  // as that would produce /dashboard/undefined links in the nav.
  const effectiveTenantId = tenantId || selectedTenant?.id;
  const base = effectiveTenantId ? `/dashboard/${effectiveTenantId}` : null;

  // Don't render nav links until we have a valid tenant to anchor them to
  if (!base) return <List />;

  return (
    <List> {/* Ensure that ListItemButton components are wrapped inside List */}
      <ListItemButton component={Link} to={base} onClick={() => handleTrackEvent('Navigate to Dashboard')}>
        <ListItemIcon>
          <DashboardIcon style={{fill:"white" }} />
        </ListItemIcon>
        <ListItemText primary="Dashboard" />
      </ListItemButton>
      <ListItemButton component={Link} to={`${base}/create`} onClick={() => handleTrackEvent('Navigate to Generate')}>
        <ListItemIcon>
          <AutoAwesomeIcon style={{fill:"white" }} />
        </ListItemIcon>
        <ListItemText primary="Generate Data" />
      </ListItemButton>
      <ListItemButton component={Link} to={`${base}/clinical-trials`} onClick={() => handleTrackEvent('Navigate to Clinical Trials')}>
        <ListItemIcon>
          <ScienceIcon style={{fill:"white" }} />
        </ListItemIcon>
        <ListItemText primary="Clinical Trials" />
      </ListItemButton>
      <ListItemButton component={Link} to={`${base}/settings`} onClick={() => handleTrackEvent('Navigate to Settings')}>
        <ListItemIcon>
          <GearIcon style={{fill:"white" }} />
        </ListItemIcon>
        <ListItemText primary="Settings" />
      </ListItemButton>
      {/* <ListItemButton component={Link} to="/dashboard/upload-schema" onClick={() => handleTrackEvent('Navigate to UploadSchema')}>
        <ListItemIcon>
          <FileUploadIcon style={{fill:"white" }} />
        </ListItemIcon>
        <ListItemText primary="Create Dataset" />
      </ListItemButton> */}

      {/* Conditionally render tenant link if selectedTenant is available */}
      {/* {selectedTenant && (
        <ListItemButton 
          component={Link} 
          to={`/dashboard/tenant/${selectedTenant.name}`} // Use tenant name dynamically
          onClick={() => handleTrackEvent('Navigate to Tenant Details')}
        >
          <ListItemIcon>
            <DashboardIcon style={{fill:"white" }} /> 
          </ListItemIcon>
          <ListItemText primary="Tenant Details" />
        </ListItemButton>
      )} */}
    </List>
  );
};


    {/* <ListItemButton component={Link} to="/dashboard/people" onClick={() => handleTrackEvent('Navigate to People List')} // Track event on click
    >
      <ListItemIcon>
        <PeopleIcon style={{fill:"white" }} />
      </ListItemIcon>
      <ListItemText primary="People" />
    </ListItemButton>
    <ListItemButton component={Link} to="/dashboard/admissions" onClick={() => handleTrackEvent('Navigate to Admissions')}>
      <ListItemIcon>
        <AssignmentIcon style={{fill:"white" }} />
      </ListItemIcon>
      <ListItemText primary="Admissions" />
    </ListItemButton> */}

export const secondaryListItems = (
  <React.Fragment>
    {/* <ListSubheader component="div" inset>
      Saved reports
    </ListSubheader>
    <ListItemButton>
      <ListItemIcon>
        <AssignmentIcon />
      </ListItemIcon>
      <ListItemText primary="Current month" />
    </ListItemButton>
    <ListItemButton>
      <ListItemIcon>
        <AssignmentIcon />
      </ListItemIcon>
      <ListItemText primary="Last quarter" />
    </ListItemButton>
    <ListItemButton>
      <ListItemIcon>
        <AssignmentIcon />
      </ListItemIcon>
      <ListItemText primary="Year-end sale" />
    </ListItemButton> */}
  </React.Fragment>
);
